import CHEVRON_DOWN from "@/assets/icons/chevron-down.svg";
import CHECK_ICON from "@/assets/icons/check.svg";
import { ChangeEvent, FC, useState } from "react";
import { InputPhoneNumberPropTypes, OptionItemPhoneNumber } from "./model";
import { makeOnlyNumber } from "@/utils/number";
import "./style.scss";

const InputPhoneNumber: FC<InputPhoneNumberPropTypes> = ({
  value,
  inputValue,
  options,
  onChange = () => {},
  onChangeInputValue,
  disabled,
  width,
  placeholder,
  isError = false,
  errorText,
}) => {
  const [showOption, setShowOption] = useState<boolean>(false);

  function handleClick() {
    setShowOption(false);
    document.removeEventListener("click", handleClick);
  }

  const onTriggerOption = () => {
    if (!disabled) {
      if (!showOption) {
        setTimeout(() => {
          document.addEventListener("click", handleClick);
        }, 500);
      } else {
        document.removeEventListener("click", handleClick);
      }

      setShowOption(!showOption);
    }
  };

  const onClickOption = (optionItem: OptionItemPhoneNumber) => {
    onChange(optionItem);
    setShowOption(false);
  };

  const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeInputValue(makeOnlyNumber(e.target.value));
  };

  return (
    <div
      className={
        "input-phone-number-component-wrapper" + (disabled ? " disabled" : "")
      }
      style={{ width: width ? width : "400px" }}
    >
      <div className="input-box" style={{ width: width ? width : "400px" }}>
        <span className="click-area" onClick={onTriggerOption}>
          <span className="phone-char-code">
            {value?.countryCode ? value?.countryCode : ""}
          </span>
          <img src={CHEVRON_DOWN} alt="chevron-phone-number" />
        </span>
        <span className="phone-code">
          {value?.countryPhoneCode ? value?.countryPhoneCode : ""}
        </span>
        <input
          type="text"
          value={inputValue}
          onChange={onChangeInput}
          disabled={disabled}
          style={{ width: width ? `calc(${width} - 92px)` : "" }}
          placeholder={placeholder}
        />
      </div>

      {showOption && (
        <div className="option-list" style={{ width: width ? width : "400px" }}>
          {options.map((option: OptionItemPhoneNumber) => (
            <div
              className={
                "option-item" +
                (value?.countryPhoneCode === option?.countryPhoneCode
                  ? " selected"
                  : "")
              }
              key={option.countryLabel}
              onClick={() => onClickOption(option)}
            >
              <img src={option.imgSrc} alt="char-code-icon" />
              <span className="country-name">{option.countryLabel}</span>
              <span className="country-code">{option.countryPhoneCode}</span>

              {value?.countryPhoneCode === option?.countryPhoneCode && (
                <img className="check-list" src={CHECK_ICON} alt="chec-icon" />
              )}
            </div>
          ))}
        </div>
      )}
      {isError && (
        <span className="input-phone-number-component-error-text">
          {errorText}
        </span>
      )}
    </div>
  );
};

export default InputPhoneNumber;
